import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=acffe8a2&scoped=true&"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckBox.vue?vue&type=style&index=0&id=acffe8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acffe8a2",
  null
  
)

export default component.exports